<template>
  <div
    class="catalogWrap"
    v-wechat-title="
      ($route.meta.title = bookInfo.name
        ? bookInfo.name + '-目录-源石阅读'
        : '源石阅读')
    "
  >
    <div v-bind:style="{ minHeight: minheight + 'px' }">
      <Header></Header>
      <div class="readRecord"></div>
      <div class="catalogCon">
        <!-- 书名 -->
        <div class="bookInfo">
          <div class="bookhint">
            {{ bookInfo.finished ? "已完结" : "连载中" }}
          </div>
          <p>{{ bookInfo.name }}</p>
          <div class="toBottom" @click="goBottom">
            直达底部
          </div>
        </div>
        <!-- 目录 -->
        <div class="bookDirectory">
          <div
            v-for="(item, index) in bookDirectory"
            :key="index"
            class="workInfomation"
          >
            <h3 class="clearfix volist">
              <p class="fl">{{ item.name }}</p>
            </h3>
            <ul class="clearfix">
              <li
                class="fl clearfix"
                v-for="(chapter, cindex) in item.chapters"
                :key="chapter.id"
                @click="goSee(bookId, chapter.id, chapter.free)"
              >
                <a href="javaScript:" class="fl ellipsis">
                  {{ chapter.name }}
                </a>
                <div class="vipbox fl" v-if="chapter.free == false">
                  <img class="vip" src="~img/book/vip@2x.png" />
                </div>
                <div
                  class="vipbox fl"
                  v-if="
                    bookDirectory.length - 1 == index &&
                      item.chapters.length - 1 == cindex
                  "
                >
                  <img class="vip" src="~img/book/tag_new.svg" />
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="fixedbox">
          <a href="javaScript:" @click="gocatalog" class="fixitem golist">
            <img src="~img/book/list.svg" alt="" />
            <p>目录</p>
          </a>
          <a href="javaScript:" @click="goCollect" class="fixitem gocollect">
            <img src="~img/book/bookShelf.svg" alt="" />
            <p>书架</p>
          </a>
          <a href="javaScript:" @click="backTop" class="gotop fixitem">
            <img src="~img/book/top.svg" alt="" />
            <p>顶部</p>
          </a>
        </div>
      </div>
    </div>

    <Footer></Footer>
    <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
  </div>
</template>

<script>
import { Bookmenu } from "apiurl/book";
export default {
  data() {
    return {
      bookDirectory: [],
      firstchapterId: null,
      bookid: null,
      bookInfo: {},
      scrollTop: 0,
      ApplyInfo: {
        isShow: false,
        title: "温馨提示",
        content: "此章节为收费章节,请到黑岩网阅读！",
        hint: "* www.heiyan.com",
        sure: "确定",
        cancle: "取消"
      },
      minheight: null
    };
  },
  created() {
    this.$nextTick(() => {
      this.bookId = this.$route.params.id;
      // 获取书籍目录
      this.BookMenu();
    });
  },
  methods: {
    // 获取书籍目录
    async BookMenu() {
      let res = await Bookmenu({ bookId: this.bookId });
      if (res.success) {
        this.bookInfo = res.data.book;
        this.bookDirectory = res.data.menu;
        this.firstchapterId = this.bookDirectory[0].chapters[0].id;
      }
    },
    // 去指定章节
    goSee(bookid, chapterid, free) {
      /*  if (free) {
        this.$router.push(`/book/${bookid}/${chapterid}`);
      } else {
        this.ApplyInfo.isShow = true;
      } */
      if (free) {
        localStorage.setItem("isfree", "true");
      } else {
        localStorage.setItem("isfree", "false");
      }
      this.$router.push(`/book/${bookid}/${chapterid}`);
    },
    // 去底部
    goBottom() {
      $("html,body").animate(
        { scrollTop: document.getElementsByTagName("body")[0].scrollHeight },
        200
      );
    },
    // 去我的书架
    goCollect() {
      this.$router.push("/personal/collect");
    },
    // 去目录
    gocatalog() {
      this.$router.push(`/list/${this.bookInfo.id}`);
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      var timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    passbind() {
      this.ApplyInfo.isShow = false;
    }
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.minheight = document.documentElement.clientHeight - 200; //监听浏览器窗口变化
    window.onresize = () => {
      this.minheight = document.documentElement.clientHeight - 200;
    };
  }
};
</script>

<style lang="stylus" scoped>
.readRecord
    height 48px
.catalogCon
    width 1009px
    box-sizing border-box
    background #fff
    margin 0px auto
    padding-top 19px
    padding-right 20px
    padding-left 20px
    .bookInfo
        margin 0 auto 26px
        height 42px
        position relative
        .bookhint
            position absolute
            top 9px
            left 0
            width 74px
            height 26px
            background rgba(72, 162, 223, 1)
            border-radius 0px 15px 15px 0px
            color #fff
            font-size 14px
            line-height 26px
            text-align center
        .toBottom
            position absolute
            top 8px
            right 12px
            width 74px
            height 26px
            background rgba(72, 162, 223, 1)
            border-radius 15px
            color #fff
            font-size 14px
            line-height 26px
            text-align center
            cursor pointer
        p
            text-align center
            font-size 30px
            color #666666
            line-height 42px
    .bookDirectory
        padding-bottom 34px
        .workInfomation
            margin-top 19px
            margin-left 9px
            h3
                height 22px
                line-height 22px
                padding 0
                color rgba(51, 51, 51, 1)
                background #fff
                border-bottom 1px solid #999
                padding-bottom 12px
        img
            width 22px
            height 22px
            margin-right 10px
        p
            height 22px
            line-height 22px
            color #333333
            font-size 16px
            font-family PingFangSC
            font-weight 600
        ul
            padding-bottom 10px
            &:last-child
                padding-bottom 0px
            li
                width 33.333%
                border-bottom 1px solid #F7F7F7
                padding 12px 0
                a
                    font-size 14px
                    max-width 70%
                    font-weight 400
                    color #555
                    &:hover
                        color #0ca3e5
                .vip
                    width 20px
                    height 20px
                    margin-left 14px
</style>
